"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = flexLeftColumn;
function flexLeftColumn() {
  return /*css*/"\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: flex-start;\n  ";
}